import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { UI_SearchField } from 'ui/components/3-organisms/SearchField/SearchField';
import { UI_BlurbCard } from 'ui/components/2-molecules/Card/BlurbCard/BlurbCard';
import { UI_Spinner } from 'ui/components/1-atoms/Media/Spinner/Spinner';
import { UI_Form } from 'ui/components/3-organisms/Form/Form';
import { UI_Paragraph } from 'ui/components/1-atoms/Paragraph/Paragraph';
import styles from './Search.module.scss';
import { UI_Grid } from 'ui/components/4-habitats/Grid/Grid';
import { UI_GridCell } from 'ui/components/4-habitats/Grid/GridCell';

export interface SearchResultsProps {
	numberOfResults: number;
	query: string;
	results: {
		heading?: string;
		link: {
			url: string;
		};
		kicker?: string;
		text?: string;
		date?: Date;
	}[];
}

export interface SearchProps {
	error: string;
	isLoading: boolean;
	searchButtonText: string;
	searchInputPlaceholder: string;
	requiredFieldErrorMessage: string;
	searchResult: SearchResultsProps;
	searchResultText: string;
	searchErrorText: string;
	getSearchResults: (query: string) => void;
}

export const UI_Search = ({
	error,
	isLoading,
	searchButtonText,
	searchInputPlaceholder,
	requiredFieldErrorMessage,
	searchResult,
	searchResultText,
	searchErrorText,
	getSearchResults,
}: SearchProps) => {
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm<{ query: string }>();

	const [searchQuery, setSearchQuery] = useState('');

	const onSubmit = async ({ query }) => setSearchQuery(query);

	const { numberOfResults, query, results } = searchResult ?? {};

	useEffect(() => {
		getSearchResults(searchQuery);
	}, [getSearchResults, searchQuery]);

	return (
		<div className={`${styles.Search}`}>
			<UI_Form onSubmit={handleSubmit(onSubmit)} className={`${styles.Search_form}  u-bottom-margin--lg`}>
				<UI_SearchField
					buttonText={searchButtonText}
					id="search"
					name="query"
					placeholder={searchInputPlaceholder}
					register={register}
					state={errors.query ? { hasError: true, required: true } : { required: true }}
					errorMessage={requiredFieldErrorMessage}
					className={errors.query && 'hasError'}
				/>
				{error && <p className={styles.Search_error}>{searchErrorText}</p>}
				{results && query && (
					<UI_Paragraph className={styles.Search_numberOfResults}>
						{searchResultText.replace('${numberOfResults}', numberOfResults?.toString())}: <b>{query}</b>
					</UI_Paragraph>
				)}
			</UI_Form>
			{isLoading && <UI_Spinner />}
			{results && results.length !== 0 && (
				<UI_Grid container wrap rowGap>
					{results?.map((result, index) => (
						<UI_GridCell key={index}>
							<UI_BlurbCard {...result} type="bordered" />
						</UI_GridCell>
					))}
				</UI_Grid>
			)}
		</div>
	);
};
